export const METRIC_DATA_FIELD_KEYS = {
  REVENUE: 'revenue',
  REVENUE_IN_LOCAL_CURRENCY: 'revenue_in_local_currency',
  COST: 'cost',
  COST_IN_LOCAL_CURRENCY: 'cost_in_local_currency',
} as const;
